import React, { useEffect, useState, useRef } from "react";
import { useBetaForm as useBetaForm } from "@locoworks/reusejs-toolkit-react-hooks";
import { useSelector } from "react-redux";
import PrimaryInput from "../../Inputs/PrimaryInput";
import Divider from "../../common/Divider";
import { PickerSelectSimple } from "@reusejs/react";
import {
  TextInputBase,
  ButtonBase,
  FileUploaderBase,
  LabelBase,
} from "@reusejs/react";
import {
  convertAmountInWord,
  createFile,
  getAuctionEventById,
  getAuctionEventByUuid,
  updateBidderForEvent,
} from "services";
import Loader from "../../../layouts/Loader";
import { useRouter } from "next/router";

const SubmitEmdForm = ({ bidderData, id, currentStep, nextStep }: any) => {
  const [event, setEvent] = useState<any>([]);
  console.log("id::>", bidderData);
  console.log("check id::>", "01341a3b-7e19-446a-bc9a-43e20728f977");

  const router = useRouter();
  const fileRef: any = useRef();

  const onboarding: any = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const emdPaymentForm = useBetaForm({
    emd_type: "",
    emd_payment_proof: "",
    emd_amount: "",
    emd_transaction_id: "",
    emd_proof: "",
    bidding_amount: "",
    bidding_amount_in_words: convertAmountInWord(Number(event?.final_price)),
    account_name: bidderData?.application_form_data?.account_name,
    account_type: bidderData?.application_form_data?.account_type,
    account_number: bidderData?.application_form_data?.account_number,
    bank_name: bidderData?.application_form_data?.bank_name,
    ifsc_code: bidderData?.application_form_data?.ifsc_code,
  });

  useEffect(() => {
    if (bidderData && bidderData?.payment_data) {
      preFillData(bidderData?.payment_data);
    }
  }, [bidderData]);

  const [selectedFile, setSelectedFile] = useState<any>([]);
  const [frontUploadedFile, setFrontUploadedFile] = useState<any>(null);

  const handleSubmit = async () => {
    let payload = bidderData;
    if (emdPaymentForm.validate()) {
      emdPaymentForm.startProcessing();
      payload["payment_data"] = {
        emd_type: emdPaymentForm.value.emd_type.value,
        emd_payment_proof: emdPaymentForm.value.emd_payment_proof,
        emd_amount: emdPaymentForm.value.emd_amount,
        emd_transaction_id: emdPaymentForm.value.emd_transaction_id,
        emd_proof:
          emdPaymentForm.value.emd_type.value === "demand_draft"
            ? "Copy of DD"
            : "Proof of Transaction",
        bidding_amount: emdPaymentForm.value.bidding_amount,
        bidding_amount_in_words: emdPaymentForm.value.bidding_amount_in_words,
        account_name: emdPaymentForm.value.account_name,
        account_type: emdPaymentForm.value.account_type,
        account_number: emdPaymentForm.value.account_number,
        bank_name: emdPaymentForm.value.bank_name,
        ifsc_code: emdPaymentForm.value.ifsc_code,
      };

      const res = await updateBidderForEvent(payload);
      if (res) {
        router.push(`/kyc/${id}?step=${nextStep}`);
      }
      emdPaymentForm.finishProcessing();
    }
  };

  const preFillData = (data: any) => {
    if (data) {
      emdPaymentForm.setField("emd_type", data?.emd_type ? data?.emd_type : "");
      emdPaymentForm.setField(
        "emd_payment_proof",
        data?.emd_payment_proof ? data?.emd_payment_proof : ""
      );
      emdPaymentForm.setField(
        "emd_amount",
        data?.emd_amount ? data?.emd_amount : ""
      );
      emdPaymentForm.setField(
        "emd_transaction_id",
        data?.emd_transaction_id ? data?.emd_transaction_id : ""
      );
      emdPaymentForm.setField(
        "emd_proof",
        data?.emd_proof ? data?.emd_proof : ""
      );
      emdPaymentForm.setField(
        "bidding_amount",
        data?.bidding_amount ? data?.bidding_amount : ""
      );
      emdPaymentForm.setField(
        "bidding_amount_in_words",
        data?.bidding_amount_in_words ? data?.bidding_amount_in_words : ""
      );
      emdPaymentForm.setField(
        "account_name",
        data?.account_name ? data?.account_name : ""
      );
      emdPaymentForm.setField(
        "account_type",
        data?.account_type ? data?.account_type : ""
      );
      emdPaymentForm.setField(
        "account_number",
        data?.account_number ? data?.account_number : ""
      );
      emdPaymentForm.setField(
        "bank_name",
        data?.bank_name ? data?.bank_name : ""
      );
      emdPaymentForm.setField(
        "ifsc_code",
        data?.ifsc_code ? data?.ifsc_code : ""
      );
    }
  };

  const getEventData = async () => {
    const response: any = await getAuctionEventByUuid(bidderData?.event_uuid);
    setEvent(response);
    emdPaymentForm.setField(
      "bidding_amount",
      response?.property_dump?.bidding_amount
    );
    emdPaymentForm.setField(
      "bidding_amount_in_words",
      convertAmountInWord(Number(response?.final_price))
    );
    emdPaymentForm.setField("emd_amount", response?.property_dump?.emd_amount);
  };

  const emdPaymentForm_constraints = {
    emd_type: {
      presence: { allowEmpty: false },
    },
    emd_transaction_id: {
      presence: { allowEmpty: false },
    },
    emd_payment_proof: {
      presence: { allowEmpty: false },
    },
  };

  useEffect(() => {
    emdPaymentForm.setValidationRules(emdPaymentForm_constraints);
    getEventData();
  }, []);

  return (
    <div className="min-h-screen mx-auto">
      <div className="mx-auto max-w-5xl border py-6 px-12 rounded-md space-y-6">
        <div className="flex flex-col justify-center items-center">
          <h2 className="font-bold tracking-wide text-2xl">EMD Payment</h2>
          <p className="tracking-tighter pt-1 text-gray-400">
            Read carefully before proceeding
          </p>
        </div>
        <div className="flex justify-center gap-y-4">
          <div className="flex flex-col gap-y-4">
            <div className="">
              <PickerSelectSimple
                dataSource={async (c) => {
                  return [
                    {
                      value: "demand_draft",
                      label: "Demand Draft",
                    },
                    {
                      value: "online_transfer",
                      label: "Online Transfer",
                    },
                  ];
                }}
                defaultString="Select Document"
                defaultSelected={
                  emdPaymentForm.getField("emd_type") !== ""
                    ? emdPaymentForm.getField("emd_type") === "demand_draft" ||
                      emdPaymentForm.getField("emd_type") === "online_transfer"
                      ? [
                          {
                            value: emdPaymentForm.getField("emd_type"),
                            label:
                              emdPaymentForm.getField("emd_type") ===
                              "demand_draft"
                                ? "Demand Draft"
                                : "Online Transfer",
                          },
                        ]
                      : [emdPaymentForm.getField("emd_type")]
                    : []
                }
                labelBaseProps={{
                  label: "EMD type",
                }}
                onChange={(value: any) =>
                  emdPaymentForm.setField("emd_type", value)
                }
                valueKey="value"
                multiple={false}
                enableClear={false}
                enableClose={false}
                enableSearch={false}
                disabled={false}
                error={
                  emdPaymentForm.errors.get("emd_type") ? (
                    <p className="mt-2 text-sm text-red-500">
                      {emdPaymentForm.errors.get("emd_type")[0]}
                    </p>
                  ) : null
                }
              />
            </div>
            <div className="">
              <TextInputBase
                autoComplete="off"
                labelBaseProps={{
                  label: "Transaction Id",
                }}
                name={"emd_transaction_id"}
                onChange={(val) => {
                  emdPaymentForm.setField("emd_transaction_id", val);
                }}
                type={"text"}
                placeholder="Enter Transaction Id"
                error={
                  emdPaymentForm.errors.get("emd_transaction_id") ? (
                    <p className="mt-2 text-sm text-red-500">
                      {emdPaymentForm.errors.get("emd_transaction_id")[0]}
                    </p>
                  ) : null
                }
                textInputBaseClasses={{
                  formInput:
                    "outline-none borber-0 focus:ring-0 focus:border-gray-300",
                }}
                value={emdPaymentForm.getField("emd_transaction_id")}
                disabled={false}
                htmlFor={"emd_transaction_id"}
              />
            </div>
            <div className="sm:flex sm:justify-between space-y-4 sm:space-y-0">
              {emdPaymentForm.getField("emd_payment_proof") ? (
                <div className="h-48 w-72 sm:w-[600px] cursor-pointer">
                  <img
                    className="h-full w-full rounded-md object-cover"
                    src={emdPaymentForm.getField("emd_payment_proof")}
                  />
                </div>
              ) : (
                <div className="">
                  <FileUploaderBase
                    ref={fileRef}
                    multiple={false}
                    accept={"*/*"}
                    autoUpload={true}
                    upload={async (uploadedFile) => {
                      const data: any = await createFile(uploadedFile, {
                        owner_identifier: bidderData?.uuid,
                        owner_service: "bidder-payment-data",
                      });
                      setFrontUploadedFile(data);
                      emdPaymentForm.setField(
                        "emd_payment_proof",
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${data.uuid}?fm=jpg`
                      );
                    }}
                    beforeUpload={(uploadedFiles) => {
                      console.log("beforeUpload:beforeUpload:>", uploadedFiles);
                    }}
                    afterUpload={async (uploadedFiles) => {
                      console.log("beforeUpload:afterUpload:>", uploadedFiles);
                    }}
                    openFileUploader={(triggerClickHandler) => (
                      <div
                        className="h-48 w-72 sm:w-[600px] cursor-pointer"
                        onClick={async () => await triggerClickHandler()}
                      >
                        {selectedFile.length > 0 ? (
                          <img
                            className="h-full w-full rounded-md object-cover"
                            src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${frontUploadedFile?.uuid}?fm=jpg`}
                          />
                        ) : (
                          <label className="w-full h-full flex flex-col justify-center items-center px-4 py-6 bg-white text-gray-600 rounded-lg shadow-lg tracking-wide uppercase border hover:bg-blue-200 hover:border-blue-600 hover:text-blue-600">
                            <svg
                              className="w-8 h-8"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span className="mt-2 text-base leading-normal">
                              Select a file
                            </span>
                          </label>
                        )}
                      </div>
                    )}
                    selectedFiles={(file) => {
                      console.log("selected file:>", file);
                      setSelectedFile(file);
                    }}
                  />
                  {!emdPaymentForm.errors.get("emd_payment_proof") && (
                    <label
                      htmlFor="front"
                      className="block text-sm font-medium text-gray-500 mt-3"
                    >
                      Please upload the image of your document.
                    </label>
                  )}
                  {emdPaymentForm.errors.get("emd_payment_proof") ? (
                    emdPaymentForm.errors.get("emd_payment_proof")[0] ===
                    "Emd payment proof can't be blank" ? (
                      <p className="mt-2 text-sm text-red-500">
                        No Documents Uploaded!
                      </p>
                    ) : (
                      <p className="mt-2 text-sm text-red-500">
                        {emdPaymentForm.errors.get("emd_payment_proof")[0]}
                      </p>
                    )
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
        <table className="w-full border-collapse border border-gray-200">
          <caption className="caption-top text-lg font-bold mt-4">
            EMD and BIDDING DETAILS
          </caption>
          <tbody>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                EMD Type
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {emdPaymentForm.getField("emd_type") == "demand_draft" ||
                emdPaymentForm.getField("emd_type") == "online_transfer"
                  ? emdPaymentForm.getField("emd_type")?.split("_").join(" ")
                  : emdPaymentForm.value.emd_type.value?.split("_").join(" ")}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                EMD Amount
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {event?.property_dump?.emd_amount}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                DD No / Online Transfer Unique Reference Number
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {emdPaymentForm.value?.emd_transaction_id}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                Transaction Information / Receiver Information
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                <ul className="flex flex-col">
                  <li>Account Name :{event?.emd_payment_account_bank}</li>
                  <li>Account Number : {event?.emd_payment_account_number}</li>
                  <li>Bank Name : {event?.emd_payment_account_branch}</li>
                  <li>IFSC Code : {event?.emd_payment_account_ifsc}</li>
                </ul>
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                Proof of EMD (Scan Image / Bank Acknowledgement/ Transaction
                Receipt to be attached. Before Final Submission)
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {emdPaymentForm.value.emd_type.value === "demand_draft"
                  ? "Copy of DD"
                  : "Proof of Transaction"}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                BIDDING AMOUNT
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {event?.final_price}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                BIDDING AMOUNT IN WORDS
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {convertAmountInWord(Number(event?.final_price))}
              </td>
            </tr>
          </tbody>
        </table>
        <table className="w-full border-collapse border border-gray-200">
          <caption className="text-sm font-semibold not-italic leading-6 mt-4 text-start capitalize">
            EMD Refund Details (In-case of un-successful bidding also please
            attach the copy of cancelled cheque/bank statement containing
            account details during final submission)
          </caption>
          <tbody>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                Account Name
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {bidderData?.application_form_data?.account_name}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                Account Type
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {bidderData?.application_form_data?.account_type}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                Account Number
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {bidderData?.application_form_data?.account_number}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                Bank Name
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {bidderData?.application_form_data?.bank_name}
              </td>
            </tr>
            <tr className="flex flex-wrap">
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                IFSC Code
              </td>
              <td className="w-1/2 p-2 border border-gray-200 text-xs font-normal leading-4 text-black capitalize">
                {bidderData?.application_form_data?.ifsc_code}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="flex justify-end text-center pt-2">
          <ButtonBase
            variant="primary"
            type="button"
            label={"Save & Submit"}
            onClick={() => handleSubmit()}
            buttonBaseClasses={{
              font: "text-base font-medium",
              backgroundColor: "bg-green-600 hover:bg-green-700",
              textColor: "text-white",
              border: "any",
              padding: "px-4 py-2",
            }}
            busy={emdPaymentForm.busy}
            busyText={<Loader height="h-6" width="w-6" />}
          />
        </div>
      </div>
    </div>
  );
};

export default SubmitEmdForm;
